import { render, staticRenderFns } from "./PersistWalletView.vue?vue&type=template&id=6a7f4a82&scoped=true"
import script from "./PersistWalletView.vue?vue&type=script&lang=ts"
export * from "./PersistWalletView.vue?vue&type=script&lang=ts"
import style0 from "./PersistWalletView.vue?vue&type=style&index=0&id=6a7f4a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7f4a82",
  null
  
)

export default component.exports